"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAllowlistResponseSchema = exports.AdminAllowlistEntrySchema = exports.AdminAllowlistQuerySchema = exports.ALLOWLIST_STATUS_FILTERS = exports.AllowlistImportIssueSchema = exports.ALLOWLIST_ISSUE_REASONS = exports.AdminAllowlistInviteSchema = exports.AllowlistBotLinkResultSchema = exports.AllowlistBotLinkRequestSchema = exports.AllowlistInviteRequestSchema = exports.AllowlistImportResultSchema = exports.AllowlistImportRequestSchema = exports.InviteLocaleSchema = exports.AllowlistRowSchema = exports.ALLOWLIST_IMPORT_MAX_ROWS = void 0;
const zod_1 = require("zod");
const locale_1 = require("../locale");
const auth_1 = require("./auth");
const onboarding_1 = require("./onboarding");
const common_1 = require("./admin/common");
exports.ALLOWLIST_IMPORT_MAX_ROWS = 5000;
exports.AllowlistRowSchema = zod_1.z.object({
    publicId: zod_1.z.string().trim().pipe(auth_1.PublicIdSchema),
    email: onboarding_1.EmailSchema,
});
/** Operator-chosen language of the invitation email; there is no user yet to read a locale from. */
exports.InviteLocaleSchema = zod_1.z.enum(locale_1.LOCALES).default('uk');
exports.AllowlistImportRequestSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.AllowlistRowSchema).min(1).max(exports.ALLOWLIST_IMPORT_MAX_ROWS),
    inviteLocale: exports.InviteLocaleSchema,
});
exports.AllowlistImportResultSchema = zod_1.z.object({
    inserted: zod_1.z.number().int().nonnegative(),
    updated: zod_1.z.number().int().nonnegative(),
    skipped: zod_1.z.number().int().nonnegative(),
    /** Invitation emails queued, one per inserted row (spec 2026-10-21 §5). */
    invited: zod_1.z.number().int().nonnegative(),
});
exports.AllowlistInviteRequestSchema = zod_1.z.object({ locale: exports.InviteLocaleSchema });
exports.AllowlistBotLinkRequestSchema = zod_1.z.object({ locale: exports.InviteLocaleSchema });
exports.AllowlistBotLinkResultSchema = zod_1.z.object({ queued: zod_1.z.number().int().nonnegative() });
/** Latest invitation delivery of an entry; `at` is sentAt / failedAt / queuedAt by status. */
exports.AdminAllowlistInviteSchema = zod_1.z.object({
    status: zod_1.z.enum(['queued', 'sent', 'failed']),
    at: zod_1.z.iso.datetime(),
});
exports.ALLOWLIST_ISSUE_REASONS = [
    'invalid_format',
    'duplicate_in_file',
    'id_taken_by_user',
    'email_taken_by_user',
    'used_entry_mismatch',
    'id_used_by_other_entry',
];
/** `line` is the 1-based position in the `rows` array; the admin app maps it back to the file line. */
exports.AllowlistImportIssueSchema = zod_1.z.object({
    line: zod_1.z.number().int().min(1),
    field: zod_1.z.enum(['publicId', 'email', 'row']),
    reason: zod_1.z.enum(exports.ALLOWLIST_ISSUE_REASONS),
});
exports.ALLOWLIST_STATUS_FILTERS = ['all', 'pending', 'used'];
exports.AdminAllowlistQuerySchema = common_1.CursorQuerySchema.extend({
    q: zod_1.z.string().trim().min(1).max(100).optional(),
    status: zod_1.z.enum(exports.ALLOWLIST_STATUS_FILTERS).default('all'),
});
exports.AdminAllowlistEntrySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    publicId: zod_1.z.string(),
    email: zod_1.z.string(),
    status: zod_1.z.enum(['pending', 'used']),
    user: zod_1.z
        .object({ id: zod_1.z.uuid(), username: zod_1.z.string().nullable(), telegramId: zod_1.z.string() })
        .nullable(),
    importedBy: zod_1.z.object({ id: zod_1.z.uuid(), name: zod_1.z.string() }),
    createdAt: zod_1.z.iso.datetime(),
    updatedAt: zod_1.z.iso.datetime(),
    usedAt: zod_1.z.iso.datetime().nullable(),
    invite: exports.AdminAllowlistInviteSchema.nullable(),
});
exports.AdminAllowlistResponseSchema = (0, common_1.pageSchema)(exports.AdminAllowlistEntrySchema);
//# sourceMappingURL=registration-allowlist.js.map